import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getVendorsSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.Vendors.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/vendors?${queryString}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_VENDORS_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_VENDORS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_VENDORS_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createVendorSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { formData } = payload;
        const { data } = yield API.post("/vendors", formData);
        if (data.success) {
            yield put({ type: actionTypes.CREATE_VENDOR_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_VENDORS, params: {} });
        } else {
            toast.error(data?.message || "Could not save vendor.");
            yield put({ type: actionTypes.CREATE_VENDOR_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save vendor.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_VENDOR_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateVendorSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { id, formData } = payload;
        const { data } = yield API.put(`/vendors/${id}`, formData);
        if (data.success) {
            const { pagination } = yield select((state) => state.Vendors.VendorsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_VENDOR_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_VENDORS, params });
        } else {
            toast.error(data?.message || "Could not save updated vendor data.");
            yield put({ type: actionTypes.UPDATE_VENDOR_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated vendor data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_VENDOR_FAILURE, payload: data || { message: "Internal server error" } });
    }
}

function* updateVendorStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.patch(`/vendors/${Id}/status`);

        if (data.success) {
            const { pagination } = yield select((state) => state.Vendors.VendorsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_VENDOR_STATUS_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_VENDORS, params });
        } else {
            toast.error(data?.message || "Could not update vendor status.");
            yield put({ type: actionTypes.UPDATE_VENDOR_STATUS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update vendor status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_VENDOR_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteVendorSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/vendors/${Id}`);

        if (data.success) {
            const { pagination } = yield select((state) => state.Vendors.VendorsList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.DELETE_VENDOR_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_VENDORS, params });
        } else {
            toast.error(data?.message || "Could not delete the vendor.");
            yield put({ type: actionTypes.DELETE_VENDOR_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete the vendor.");
        const data = error?.response?.data;
        toast.error(data?.message || "Could not delete the vendor.");
        yield put({ type: actionTypes.CREATE_VENDOR_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* VendorsSaga() {
  yield all([
    takeLatest(actionTypes.GET_VENDORS, getVendorsSaga),
    takeLatest(actionTypes.CREATE_VENDOR, createVendorSaga),
    takeLatest(actionTypes.UPDATE_VENDOR, updateVendorSaga),
    takeLatest(actionTypes.UPDATE_VENDOR_STATUS, updateVendorStatusSaga),
    takeLatest(actionTypes.DELETE_VENDOR, deleteVendorSaga),
  ]);
}

export default VendorsSaga;
